import { Pipe, PipeTransform } from '@angular/core';
import { SessionData } from '../models/User.model';

@Pipe({
  name: 'username',
  standalone: true
})
export class UserNamePipe implements PipeTransform {
   transform(value: SessionData) {
      let username = '';
      if (value.userInfo && typeof value.userInfo !== 'boolean') {
         if (`${value.userInfo.firstName}`.length > 7) {
            username = `${value.userInfo.firstName?.split(' ').map(word => word[0]).join('')} ${value.userInfo.lastName}`;
         } else username = `${value.userInfo.firstName} ${value.userInfo.lastName}`;
      }
      return value.userInfo && typeof value.userInfo !== 'boolean'
         ? username
         : `Terminal ${value.keyboxLocation}`;
   }
}
